import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Modal, Table, Button, Loader} from 'semantic-ui-react';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';

class BackOrderModal extends Component {
  constructor(props) {
    super(props);
    this.handleAccept = this.handleAccept.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {partCode, showModal} = this.props;
    const isOpen = !prevProps.showModal && showModal;

    if (isOpen && partCode && prevProps.partCode !== partCode) {
      this.props.fetchBackOrdersDetail(partCode);
    }
  }

  handleAccept() {
    this.props.hideOrderPartBackOrder();
  }

  renderDate(rawDate) {
    return rawDate ? moment(rawDate).format(reverseShortDate) : null;
  }

  renderDetail() {
    const {loading, backOrderDetail} = this.props;

    if (loading) {
      return (
        <Loader active inline='centered'>Consultando información...</Loader>
      );
    }

    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fecha Pedido</Table.HeaderCell>
            <Table.HeaderCell>Usuario</Table.HeaderCell>
            <Table.HeaderCell>Concesionario</Table.HeaderCell>
            <Table.HeaderCell>Agencia</Table.HeaderCell>
            <Table.HeaderCell>Cantidad</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.renderTableBody(backOrderDetail)}
        </Table.Body>
      </Table>
    );
  }

  renderTableBody() {
    const {backOrdersData} = this.props;

    if (!backOrdersData.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='5'>
            No se encontraron registros.
          </Table.Cell>
        </Table.Row>
      );
    }


    return backOrdersData.map((backOrder, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{this.renderDate(backOrder.date)}</Table.Cell>
          <Table.Cell>{backOrder.user}</Table.Cell>
          <Table.Cell>{backOrder.dealer}</Table.Cell>
          <Table.Cell>{backOrder.agency}</Table.Cell>
          <Table.Cell>{backOrder.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {partCode, showModal} = this.props;

    return (
      <Modal
        open={showModal}
        trigger={<div />}
      >
        <Modal.Header>
          Back Order - {partCode}
        </Modal.Header>
        <Modal.Content>
          {this.renderDetail()}
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.handleAccept}>ACEPTAR</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partCode': state.providerStockOrders.partCodeForStock,
    'showModal': state.providerStockOrders.showBackOrderModal,
    'loading': state.partModals.loadingBackOrdersDetail,
    'backOrdersData': state.partModals.backOrdersDetail,
  };
};

const {
  fetchBackOrdersDetail,
  hideOrderPartBackOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchBackOrdersDetail,
  hideOrderPartBackOrder,
})(BackOrderModal);
